import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RookeryBoldFont, RookeryRegularFont } from 'v3/styles/common';

export const SubtitleSmallStyled = styled(Typography)<TypographyProps>(() => ({
  font: `400 0.813rem ${RookeryRegularFont}`,
}));

export const SubtitleSmallBoldStyled = styled(Typography)<TypographyProps>(() => ({
  font: `700 0.813rem ${RookeryBoldFont}`,
}));
